import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslations } from 'use-intl';

import { useSearchParams } from '@/lib/compat/navigation';
import { InviteAcceptContent } from '@/screens/invite/accept/InviteAcceptContent';
import { InvalidInvite } from '@/components/auth/invalid-invite';

export const Route = createFileRoute('/_app/invite/accept/')({
  component: InviteAcceptRoute,
});

function LoadingSpinner() {
  const t = useTranslations('auth');
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">{t('loading')}</p>
      </div>
    </div>
  );
}

function InviteAcceptRoute() {
  const sp = useSearchParams();
  const t = useTranslations('auth.invalidInvite');
  const token = sp.get('token') ?? undefined;

  if (!token) {
    return <InvalidInvite message={t('noToken')} />;
  }

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <InviteAcceptContent token={token} />
    </Suspense>
  );
}
